module.exports = __webpack_public_path__ + "img/levelup-icon-delivery-note.8aa8d460.svg";